import { useState } from 'react';
import type { CustomerSearchFilters } from '@/types/customer';
import './CustomerSearch.css';

interface CustomerSearchProps {
  onSearch: (query: string, filters?: CustomerSearchFilters) => void;
  loading?: boolean;
}

export const CustomerSearch = ({ onSearch, loading }: CustomerSearchProps) => {
  const [query, setQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState<CustomerSearchFilters>({});

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(query, filters);
  };

  const handleClearFilters = () => {
    setFilters({});
    onSearch(query, {});
  };

  return (
    <div className="customer-search">
      <form onSubmit={handleSubmit} className="search-form">
        <div className="search-input-wrapper">
          <input
            type="search"
            placeholder="Search by phone number, name, email, Emirates ID, or account number..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="search-input"
            disabled={loading}
          />
          <button type="submit" className="search-button" disabled={loading}>
            🔍 Search
          </button>
        </div>

        <div className="search-actions">
          <button
            type="button"
            className="btn btn-secondary btn-small"
            onClick={() => setShowFilters(!showFilters)}
          >
            {showFilters ? '▲' : '▼'} Advanced Filters
          </button>
          
          {Object.keys(filters).length > 0 && (
            <button
              type="button"
              className="btn btn-ghost btn-small"
              onClick={handleClearFilters}
            >
              Clear Filters
            </button>
          )}
        </div>
      </form>

      {showFilters && (
        <div className="advanced-filters">
          <div className="filter-row">
            <div className="filter-item">
              <label className="filter-label">Status</label>
              <select
                value={filters.status || ''}
                onChange={(e) =>
                  setFilters({ ...filters, status: e.target.value as any || undefined })
                }
                className="filter-select"
              >
                <option value="">All</option>
                <option value="active">Active</option>
                <option value="suspended">Suspended</option>
                <option value="closed">Closed</option>
              </select>
            </div>

            <div className="filter-item">
              <label className="filter-label">Country</label>
              <select
                value={filters.country || ''}
                onChange={(e) =>
                  setFilters({ ...filters, country: e.target.value || undefined })
                }
                className="filter-select"
              >
                <option value="">All</option>
                <option value="UAE">UAE</option>
                <option value="UK">UK</option>
                <option value="US">US</option>
                <option value="Pakistan">Pakistan</option>
                <option value="India">India</option>
              </select>
            </div>

            <div className="filter-item">
              <label className="filter-label">Has Open Cases</label>
              <select
                value={filters.has_open_cases !== undefined ? String(filters.has_open_cases) : ''}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    has_open_cases: e.target.value ? e.target.value === 'true' : undefined,
                  })
                }
                className="filter-select"
              >
                <option value="">All</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          </div>

          <button
            type="button"
            className="btn btn-primary btn-small"
            onClick={() => onSearch(query, filters)}
          >
            Apply Filters
          </button>
        </div>
      )}
    </div>
  );
};

